export { USER_INPUT_FILTER_ROLES } from '@wix/wix-data-client-common'
import {
  DROPDOWN_OPTIONS_ROLE,
  MOBUI_PICKER_OPTIONS_ROLE,
  SELECTION_TAGS_OPTIONS_ROLE,
  USER_INPUT_FILTER_CHECKBOX_GROUP_ROLE,
  USER_INPUT_FILTER_DROPDOWN_ROLE,
  USER_INPUT_FILTER_RADIOGROUP_ROLE,
  USER_INPUT_FILTER_SELECTION_TAGS_ROLE,
} from '@wix/wix-data-client-common-standalone'
import type { ComponentRole } from '../types'

export const RESET_ALL = 'RESET_ALL'

export const USER_INPUT_FILTER_UNIQUE_OPTIONS_LIMIT = 1000

export const USER_INPUT_FILTER_UNIQUE_DB_DRIVER_OPTIONS_LIMIT = 100

export const LIST_TYPE_USER_INPUT_FILTER_ROLES = [
  USER_INPUT_FILTER_DROPDOWN_ROLE,
  USER_INPUT_FILTER_RADIOGROUP_ROLE,
  USER_INPUT_FILTER_CHECKBOX_GROUP_ROLE,
  USER_INPUT_FILTER_SELECTION_TAGS_ROLE,
]

export const CONNECTED_OPTIONS_ROLES = [
  DROPDOWN_OPTIONS_ROLE,
  MOBUI_PICKER_OPTIONS_ROLE,
  SELECTION_TAGS_OPTIONS_ROLE,
]

export const isConnectedOptionsRole = (role: ComponentRole): boolean =>
  CONNECTED_OPTIONS_ROLES.includes(role)

export const DEPRECATED_METHODS_MAP = new Map([['new', 'add']])

export { DATA_BINDING as APP_DEF_ID } from '@wix/app-definition-ids'

export const APP_NAME = 'dbsm-viewer-app'

export const WIDGET_RECORD_ID = 'widget_record_id'
